import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import "./DoraLinkButton.scss";
const DoraLinkButton = (props) => {
    const { className, children, onClick, disabled, ...rest } = props;
    const classes = classnames("dora-link-button", className);
    return (_jsx("button", { className: classes, onClick: onClick, disabled: disabled, ...rest, children: children }));
};
export const DoraLink = (props) => {
    const { className, url, newTab, children } = props;
    const classes = classnames("dora-link-button", "dora-link", className);
    const newTabProps = newTab ? { target: "_blank", rel: "noreferrer" } : {};
    return (_jsx("a", { className: classes, href: url, ...newTabProps, children: children }));
};
export default DoraLinkButton;
//# sourceMappingURL=DoraLinkButton.js.map